const mergeFarms = rawFarms => {
  return rawFarms.reduce( (merged, page) => [...merged, ...page.farms], []);
};

export const parseAllFarms = ( rawFarms ) => {
  // an array of paged results
  const mergedRawFarms = mergeFarms(rawFarms);
  return mergedRawFarms.reduce( (parsed, farm) => {
    parsed[farm.id] = farm;
    return parsed;
  }, {});
};

